import React from "react";
import styles from "./Header.module.scss";
import { Link } from "react-router-dom";
import useHeaderActiveClass from "../../hooks/useHeaderActiveClass";
import Menu from "../Menu/Menu";
import MobileMenu from "../Menu/MobileMenu";
import useHeaderLogic from "./Header.logic";

type HeaderProps = {
  scroll: boolean;
  isMobileMenu: boolean;
  handleMobileMenu: () => void;
  isSidebar: boolean;
  handlePopup: () => void;
  handleSidebar: () => void;
};

const Header: React.FC<HeaderProps> = ({
  scroll,
  isMobileMenu,
  handleMobileMenu,
  isSidebar,
  handlePopup,
  handleSidebar,
}) => {
  const {
    user,
    isAuthenticated,
    isAdmin,
    onLogout,
    showAdminPanel,
    setIsAdminPanelState,
  } = useHeaderLogic();

  const isCurrentPath = (path: string) => {
    const currentPath = window.location.pathname;
    return currentPath === path || currentPath.startsWith(path + "/");
  };

  return (
    <header
      className={`main-header main-header-two ${scroll ? "fixed-header" : ""}`}
    >
      <nav className="main-menu main-menu-two">
        <div className="main-menu__wrapper">
          <div className="container">
            <div className="main-menu__wrapper-inner">
              <div className="main-menu__left">
                <div className="main-menu__logo">
                  <Link to="/">
                    <span className="logo_name">ImpactUp</span>
                    <span className="slogan_name">
                      Where Passion Meets Purpose.
                    </span>
                    {/* <img src="/assets/images/resources/logo-1.png" alt="Logo" /> */}
                  </Link>
                </div>
              </div>
              <div className="main-menu__main-menu-box">
                <div className="mobile-nav__toggler" onClick={handleMobileMenu}>
                  <i className="fa fa-bars" />
                </div>
                <Menu />
              </div>
              <div className="main-menu__right">
                {!isAuthenticated && (
                  <>
                    <div className="main-menu__cart-search-nav-sidebar-icon-and-btn-box">
                      <Link
                        to="login"
                        className="main-menu__cart icon-user"
                      ></Link>
                    </div>
                  </>
                )}
                {isAuthenticated && (
                  <>
                    <ul className="main-menu__list profile_menu">
                      <li
                        className={`dropdown ${
                          isCurrentPath("/profile") ? "current" : ""
                        }`}
                      >
                        <Link
                          to="#"
                          className="main-menu__cart icon-user"
                        ></Link>
                        <ul>
                          <li>
                            <Link to="/profile">Profile</Link>
                          </li>
                          {!isAdmin && (
                            <li>
                              <Link to="/transactions">Transactions</Link>
                            </li>
                          )}
                          {isAdmin && !showAdminPanel && (
                            <li>
                              <Link
                                onClick={() => setIsAdminPanelState(true)}
                                to="/admin"
                              >
                                Administration
                              </Link>
                            </li>
                          )}
                          {isAdmin && showAdminPanel && (
                            <li>
                              <Link
                                onClick={() => setIsAdminPanelState(false)}
                                to="/"
                              >
                                Exit Administration
                              </Link>
                            </li>
                          )}
                          <li>
                            <Link onClick={onLogout} to="#">
                              Logout
                              {/* <span className="icon-arrow-right"></span> */}
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </>
                )}
                <div className="main-menu__btn-box">
                  <Link to="/ngos" className="main-menu__btn thm-btn">
                    Donate Now <span className="icon-arrow-right"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div
        className={`stricky-header stricked-menu main-menu main-menu-two ${
          scroll ? "stricky-fixed" : ""
        }`}
      >
        <div className="sticky-header__content" />
        <nav className="main-menu main-menu-two">
          <div className="main-menu__wrapper">
            <div className="container">
              <div className="main-menu__wrapper-inner">
                <div className="main-menu__left">
                  <div className="main-menu__logo">
                    <Link to="/">
                      {/* <img
                        src="/assets/images/resources/logo-1.png"
                        alt="Logo"
                      /> */}
                      <span className="logo_name">ImpactUp</span>
                      <span className="slogan_name">
                        Where Passion Meets Purpose.
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="main-menu__main-menu-box">
                  <div
                    className="mobile-nav__toggler"
                    onClick={handleMobileMenu}
                  >
                    <i className="fa fa-bars" />
                  </div>
                  <Menu />
                </div>
                <div className="main-menu__right">
                  {!isAuthenticated && (
                    <>
                      <div className="main-menu__cart-search-nav-sidebar-icon-and-btn-box">
                        <Link
                          to="login"
                          className="main-menu__cart icon-user"
                        ></Link>
                      </div>
                    </>
                  )}
                  {isAuthenticated && (
                    <>
                      <ul className="main-menu__list profile_menu">
                        <li className="dropdown">
                          <Link
                            to="#"
                            className="main-menu__cart icon-user"
                          ></Link>
                          <ul>
                            <li>
                              <Link to="/profile">Profile</Link>
                            </li>
                            {!isAdmin && (
                              <li>
                                <Link to="/transactions">Transactions</Link>
                              </li>
                            )}
                            {isAdmin && !showAdminPanel && (
                              <li>
                                <Link
                                  onClick={() => setIsAdminPanelState(true)}
                                  to="#"
                                >
                                  Administration
                                </Link>
                              </li>
                            )}
                            {isAdmin && showAdminPanel && (
                              <li>
                                <Link
                                  onClick={() => setIsAdminPanelState(false)}
                                  to="#"
                                >
                                  Exit Administration
                                </Link>
                              </li>
                            )}
                            <li>
                              <Link onClick={onLogout} to="#">
                                Logout
                                {/* <span className="icon-arrow-right"></span> */}
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </>
                  )}
                  <div className="main-menu__btn-box">
                    <Link to="/ngos" className="main-menu__btn thm-btn">
                      Donate Now <span className="icon-arrow-right"></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <MobileMenu
        handleMobileMenu={handleMobileMenu}
        handleSidebar={handleSidebar}
        isSidebar={isSidebar}
      />
    </header>
  );
};

export default Header;
